// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rPpf","inner":"Footer_inner__3eJVk","nextIcon":"Footer_nextIcon__1mr4y","innerLeft":"Footer_innerLeft__1IE7h"};